
export const Particle = ({ style }) => (
  <div style={{
    position: 'fixed',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    pointerEvents: 'none',
    animation: 'float 15s infinite',
    ...style
  }} />
);
